import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Container from 'react-bootstrap/Container';
import logo from '../../images/common/kofc.png';
import { Link } from 'react-router-dom';

const Header = () => (
  <header className="App-header">
    <Navbar collapseOnSelect expand="md" bg="dark" variant="dark">
      <Container fluid>
        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
          <img src={logo} alt="kofc1056" className="App-logo me-2" style={{ maxHeight: '40px' }} />
          <span className="d-none d-md-inline">Knights of Columbus - Council 1056</span>
          <span className="d-inline d-md-none">Knights of Columbus 1056</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarScroll" />
        <Navbar.Collapse id="navbarScroll">
          <Nav className="ms-auto">
            <Nav.Link href="/">Home</Nav.Link>
            <NavDropdown title="Donate" id="navbarScrollingDropdown">
              <NavDropdown.Item href="https://kofc1056.square.site/charities">
                <i className="bi bi-credit-card me-2"></i>Credit/Debit Card
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="https://paypal.me/kofc1056?locale.x=en_US">
                <i className="bi bi-paypal me-2"></i>PayPal
              </NavDropdown.Item>
            </NavDropdown>
            <NavDropdown title="Membership" id="navbarScrollingDropdown-membership">
              <NavDropdown.Item href="https://kofc1056.square.site/dues">
                <i className="bi bi-credit-card me-2"></i>Pay Dues
              </NavDropdown.Item>
            </NavDropdown>
            <NavDropdown title="Other" id="navbarScrollingDropdown-other">
              <NavDropdown.Item href="/calendar">
                Lucky Number Calendar
              </NavDropdown.Item>
              <NavDropdown.Item href="/purchasecalendar?type=Knight-Cash">
                Lucky Num - Knight Cash
              </NavDropdown.Item>
              <NavDropdown.Item href="/purchasecalendar?type=Knight-Event">
                Lucky Num - Knight Event
              </NavDropdown.Item>
            </NavDropdown>
            <Nav.Link href="/events">Events</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  </header>
);

export default Header;
